// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3F8E7","errorLogs":"styles_errorLogs__2hsup"};